// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client'; // <-- Updated import for createRoot
import { BrowserRouter as Router } from 'react-router-dom';
import './styles.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { WorkflowProvider } from './contexts/WorkflowContext';
import { AddressProvider } from './contexts/AddressContext';
// import Providers from './contexts/Providers';

const root = ReactDOM.createRoot(document.getElementById('root')); // <-- Use createRoot
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <WorkflowProvider>
          <AddressProvider>
            <App />
          </AddressProvider>
        </WorkflowProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
